import request from "@utils/request";

export function getCityList(data) {
  return request({
    url: "/website/offlineExperienceShop/noAuth/front/v3.2.4.5/getCityList",
    method: "get",
    params: data,
  });
}


export function getOfflineStore(data) {
  let url = `/website/offlineExperienceShop/noAuth/front/v3.2.4.5/getShopList`;
  let params = {
    authorizeCityAdCode: data.authorizeCityAdCode || '',
    latitude: 0.0,
    longitude: 0.0,
    size: data.pageSize || 10,
    current: data.pageIndex || 1
  }
  if (!params.authorizeCityAdCode) {
    params.orderByField = 'letter';
  }
  return request({
    url: url,
    method: "get",
    params: params,
  });
}

export function getServiceCity(data) {
  return request({
    url: "/website/dealer/noAuth/front/v3.2.3/cityList",
    method: "get",
    params: data,
  });
}

export function getServiceStore(data) {
  return request({
    url: `/website/dealer/noAuth/front/v3.2.3/pageList`,
    method: "get",
    params: {
      latitude: 0.0,
      longitude: 0.0,
      size: data.pageSize || 10,
      current: data.pageIndex || 1,
      code: data.code || '',
    },
  });
}
export function getShopList(data) {
  return request({
    url: `/maintenance/serviceShop/noAuth/front/v3.2.4.5/getShopList`,
    method: "get",
    params: {
      latitude: 113.372908,
      longitude: 22.94675,
      type: data.type ,
      cityCode: data.cityCode,
    },
  });
}

export function cityList(type) {
  return request({
    url: `/maintenance/serviceShop/noAuth/front/v3.2.3/cityList`,
    method: "get",
    params: {
      type,
    },
  });
}